import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Session lives only in the server-set HttpOnly `lf_session` cookie (Prompt 18 E5).
// Track whether we ever confirmed a live session on this tab so the 401
// interceptor never fires the "session expired" redirect during initial
// bootstrap or immediately after a fresh login attempt.
let _authConfirmed = false;
export function markAuthConfirmed() { _authConfirmed = true; }
export function markAuthCleared() {
  _authConfirmed = false;
}

// Global 401 handler.
// Only redirect to /login?session=expired when we KNOW an authed session died
// (i.e. after a prior /auth/me succeeded). During bootstrap or immediately
// after a login attempt we let the auth provider handle the state — no false
// "session expired" banner (Prompt 06b acceptance #2, #4).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || "";
      const path = window.location.pathname;
      const isAuthEndpoint =
        url.includes("/auth/me") ||
        url.includes("/auth/login") ||
        url.includes("/auth/register");
      const alreadyAtAuthPage = path === "/login" || path === "/register";
      if (!isAuthEndpoint && !alreadyAtAuthPage && _authConfirmed) {
        _authConfirmed = false;
        window.location.href = "/login?session=expired";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
